import axios from 'axios';

import { setInterceptors } from './common/interceptors';

function createInstance() {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
  return setInterceptors(instance);
}

/*
function createInstanceWithAccount(url) {
	const instance = axios.create({
		baseURL: `${process.env.VUE_APP_API_URL}${url}`,
	});
	return setInterceptoer(instance);
}
*/

export const instance = createInstance();

function serverInfo() {
  return instance.get('api/common/echo/v1');
}

export { serverInfo };
